import { Fragment, useEffect, useReducer, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { userActions } from "../store/user-slice";
import useFetch from './../hook/useFetch';
import { notificationActions } from "../store/notification-slice";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "./InfoIcon";
import { orderActions } from "../store/orders-slice";
import { useOrder } from "../hook/useOrder";

export default function Login() {

    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'showpassform':
                return { ...state, showresetpassform: !state.showresetpassform }

        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {
        email: null,
        password: null,
        showresetpassform: false
    })

    let dispatch = useDispatch()

    const { error, update, post, get } = useFetch()

    let navigate = useNavigate()

    let resetpassemail = useRef()

    const [inputpasswordtype, setinputpasswordtype] = useState('password')

    const [inputpasswordicon, setpasswordicon] = useState(faEyeSlash)

    const {getCartItems}=useOrder()

    useEffect(() => {

        setpasswordicon(inputpasswordtype === 'text' ? faEyeSlash : faEye)

    }, [inputpasswordtype])

    return <div className="login-container" >
        <form className="login-form shadow" onSubmit={(e) => {
            e.preventDefault()

            update('/user/login', {
                email: componentState.email,
                password: componentState.password,

            }, null, (data) => {
                
                dispatch(userActions.setUser(data))
                if (data.is_admin) {
                    get('/admin/2fa', null, () => {
                        dispatch(userActions.setUser(null))
                    }, (status) => {
                        navigate(status.configured ? '/2fa/challenge' : '/2fa/setup')
                    })
                    return
                }

                getCartItems()
                navigate('/')
            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{error}</p>
                </div>
            }

            <div className="form-group">
                <label>Email address</label>
                <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.email} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label>Password</label>
              <div style={{display:'flex',alignItems:'center'}} >
                  <input type={inputpasswordtype} className="form-control" placeholder="Password" defaultValue={componentState.password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'password',
                            data: e.target.value
                        }
                    )
                }} required />
                <InfoIcon icon={inputpasswordicon} onClick={() => {
                    setinputpasswordtype(inputpasswordtype === 'text' ? 'password' : 'text')
                }} />
              </div>
            </div>

            <button type="submit" className="btn btn-primary" >Login</button>
            <a className="btn" href="#" onClick={(e) => {
                e.preventDefault()
                componentDispatch({
                    type: 'showpassform'
                })
            }} >Forgot password?</a>

            {componentState.showresetpassform &&

                <Fragment>

                    <label>Enter your email,reset link will be sent to you by email</label>
                    <input type="email" className="form-control" placeholder="Email" ref={resetpassemail} />
                    <button className="btn btn-secondary" type="button" onClick={() => {
                        if (!resetpassemail.current.value) {
                            return
                        }

                        post(`/user/reset-request?email=${resetpassemail.current.value}&redirect=${process.env.REACT_APP_BASE_URL}`, null, null, (data) => {
                            componentDispatch({
                                type: 'showpassform'
                            })
                            dispatch(notificationActions.setNotification({
                                message: data,
                                status: true
                            }))

                        })

                    }} >SendLink</button>
                </Fragment>

            }

            <Link className="btn" to='/signup' >Register</Link>
        </form>



    </div>

}
